'use client';
import { motion } from 'framer-motion';
import Image from 'next/image';

export default function Loader() {
  return (
    <div className="fixed inset-0 z-50 bg-primaryColor flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8"
      >
        {/* Logo */}
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <div className="relative w-16 h-16 sm:w-24 sm:h-24 md:w-34 md:h-34 items-baseline">
            <Image
              src="/QQQ.webp"
              
              alt="Design Nook Logo"
              fill
              style={{ objectFit: 'contain' }}
              priority
              sizes="(max-width: 640px) 4rem, (max-width: 768px) 6rem, 8rem" // Added sizes prop
            />
          </div>
        </motion.div>

        {/* Text */}
        <motion.h1 className="text-5xl font-serif md:text-7xl font-semibold text-accent flex gap-2 items-baseline">
          <motion.span
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: 'easeInOut' }}
          >
            Design
          </motion.span>
          <motion.span
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: 'easeOut', delay: 0.3 }}
          >
            Nook
          </motion.span>
        </motion.h1>
      </motion.div>
    </div>
  );
}
